import Link from 'next/link';
import { Typography } from '@/app/common/Typography';
import { cn } from '@/app/lib/utils';
import type { ProcessedFooterColumn } from '../lib/footer.utils';

export interface FooterColumnsProps {
  columns: ProcessedFooterColumn[];
  className?: string;
}

export const FooterColumns = ({ columns, className = '' }: FooterColumnsProps) => {
  return (
    <div className={cn('w-full', className)}>
      <div className="grid grid-cols-2 md:grid-cols-[repeat(4,minmax(0,auto))] gap-x-sm gap-y-xl md:gap-x-xs md:gap-y-xl footer:gap-x-2xl">
        {columns?.map((column, index) => (
          <div key={index} className="space-y-sm md:flex-shrink md:space-y-md md:min-w-0">
            <Typography
              variant="bodyMd"
              className="text-black font-semibold font-sora mb-0 min-xl:!whitespace-nowrap break-words"
            >
              {column.title}
            </Typography>
            <ul className="space-y-xs pt-sm md:pt-md font-openSans">
              {column.links?.map((link, linkIndex) => {
                const fontWeightClass = link.isBold ? '!font-bold font-sora' : '!font-extralight';
                const linkClasses =
                  'text-black !text-base hover:underline !no-underline min-xl:!whitespace-nowrap break-words';

                return (
                  <li key={linkIndex}>
                    {link.type === 'external' ? (
                      <a href={link.url} target="_blank" rel="noopener noreferrer" className="inline-block">
                        <Typography variant="link" fontWeight={fontWeightClass} className={linkClasses}>
                          {link.label}
                        </Typography>
                      </a>
                    ) : (
                      <Link
                        href={link.url}
                        className="inline-block"
                        target={link?.isOpenInNewTab ? '_blank' : undefined}
                        rel={link?.isOpenInNewTab ? 'noopener noreferrer' : undefined}
                      >
                        <Typography variant="link" fontWeight={fontWeightClass} className={linkClasses}>
                          {link.label}
                        </Typography>
                      </Link>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
